export default "__VITE_ASSET__f599e323__"